import { createContext, useContext, useEffect, useState } from 'react';
import {
    fetchAppSettingsDetailsApi,
  } from "../api/appSettingsApi";
const AppSettingsContext = createContext();

export const AppSettingsProvider = ({ children }) => {
  const [appSettings, setAppSettings] = useState({});
  
  useEffect(()=>{
    fetchApplicationSettingsDetails();
  },[])

  // Function for fetch application settings details
  const fetchApplicationSettingsDetails = async () => {
    try {
        let response = await fetchAppSettingsDetailsApi();
        if (response?.code == 200) {
            setAppSettings(response?.data || []);
        }
    } catch (err) {
        console.log("err", err.message);
    }
  };
  return (
    <AppSettingsContext.Provider value={{ appSettings, setAppSettings }}>
      {children}
    </AppSettingsContext.Provider>
  );
};

export const useAppSettings = () => useContext(AppSettingsContext);
